import * as comunicado from '@/api/comunicado'

const state = {
  list: [],
  listaSelect: [],
  filtros: {page: 1},
  countPage: 0,
  modalAdd: false,
  modalEdit: false,
  modalConfDel: false,
  listUsuario: []
}

const mutations = {
  SETCOMUNICADOS (state, payload) {
    state.list = payload.list
  },
  MODALADD (state, payload) {
    state.modalAdd = payload
  },
  MODALEDIT (state, payload) {
    state.modalEdit = payload
  },
  MODALCONFDEL (state, payload) {
    state.modalConfDel = payload
  },
  SETPAGE (state, payload) {
    state.filtros.page = payload
  },
  SETPAGINATE (state, payload) {
    if (payload === 1) state.countPage = 0
    else state.countPage = payload
  },
  SETFILTROS (state, payload) {
    if (payload) {
      state.filtros = payload
    }
  },
  SETCOMUNICADOSUSUARIO (state, payload) {
    state.listUsuario = payload
  }
}

const actions = {
  modalAdd: function ({ commit }, payload) {
    commit('MODALADD', payload)
  },
  modalEdit: function ({ commit }, payload) {
    commit('MODALEDIT', payload)
  },
  modalConfDel: function ({ commit }, payload) {
    commit('MODALCONFDEL', payload)
  },
  async get ({ commit }, payload) {
    return comunicado.get(payload)
  },
  async getComunicados ({ commit }, payload) {
    commit('SETFILTROS', payload)
    let data = await comunicado.getComunicados(payload)
    commit('SETCOMUNICADOS', data.instancia)
    commit('SETPAGINATE', data.instancia.pages)
  },
  async getComunicadosFiltro ({ commit, state, dispatch }) {
    let data = await comunicado.getComunicados(state.filtros)
    if (state.filtros.page > data.instancia.pages) dispatch('setPage', data.instancia.pages)
    else {
      commit('SETCOMUNICADOS', data.instancia)
      commit('SETPAGINATE', data.instancia.pages)
    }
  },
  async add ({ commit }, payload) {
    try {
      return comunicado.add(payload)
    } catch (e) {
      return e
    }
  },
  async edit ({ commit }, payload) {
    if (payload.instituicao) {
      payload.instituicao.id = payload.instituicao.value
    }
    if (payload.produto) {
      payload.produto.id = payload.produto.value
    }
    try {
      await comunicado.edit(payload)
      return true
    } catch (e) {
      return e
    }
  },
  async del ({ commit }, payload) {
    try {
      let retorno = await comunicado.del(payload)
      return retorno.instancia
    } catch (e) {
      return e
    }
  },
  setPage (context, payload) {
    context.commit('SETPAGE', payload)
    context.dispatch('getComunicados', state.filtros)
  },
  async getComunicadosUsuario ({ commit }, payload) {
    let data = await comunicado.getByUsuario(payload)
    commit('SETCOMUNICADOSUSUARIO', data.instancia)
  },
  async lerComunicado ({ commit }, payload) {
    try {
      await comunicado.ler(payload)
      return true
    } catch (e) {
      return e
    }
  },
  async getComunicadoNaoLido ({ commit }) {
    let comunicadoEnvelope = await comunicado.naoLido()
    return comunicadoEnvelope.instancia
  }

}

export default { namespaced: true, state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/gerenciador/comunicado.js